export const PAY_NOW_STATE = 'payNow'

export const PAY_NOW_REQUEST = 'PAY_NOW_REQUEST'
export const PAY_NOW_SUCCESS = 'PAY_NOW_SUCCESS'
export const PAY_NOW_FAILURE = 'PAY_NOW_FAILURE'
export const PAY_NOW_SET_SECURECODE = 'PAY_NOW_SET_SECURECODE'
